<div class="edit-page" [class.edit-page--collapsed]="isHeaderCollapsed()">
  <div
    class="edit-page__sticky-header"
    [class.edit-page__sticky-header--collapsed]="isHeaderCollapsed()"
  >
    <div class="edit-page__header-content">
      <button class="edit-page__back-btn" (click)="onBack()">
        <app-icon class="icon" [icon]="iconName.ARROW_LEFT_2" />
        <span>{{ 'inventory.buttons.backToInventory' | translate }}</span>
      </button>

      <h1 class="edit-page__title">
        {{ 'inventory.modalHeaders.editProduct' | translate }}
      </h1>
    </div>

    <div class="edit-page__tabs">
      @for (tab of visibleTabs(); track tab.key) {
        <button
          class="edit-page__tab"
          [class.edit-page__tab--active]="activeTab() === tab.key"
          (click)="onTabClick(tab)"
        >
          {{ tab.label | translate }}
        </button>
      }
    </div>
  </div>

  <app-edit-inventory-section
    [visibleTabs]="visibleTabs()"
    [item]="inventoryItem()"
    [form]="form"
  />

  <div class="edit-page__footer">
    <button class="edit-page__preview">
      {{ 'inventory.buttons.preview' | translate }}
    </button>
    <div class="edit-page__btn-wrapper">
      <button class="btn-white edit-page__cancel-btn" (click)="onBack()">
        {{ 'inventory.buttons.cancel' | translate }}
      </button>
      <button class="btn-primary edit-page__save-btn" [disabled]="isLoading()" (click)="onSave()">
        {{ 'inventory.buttons.save' | translate }}
      </button>
    </div>
  </div>
</div>
